import { SVGProps } from 'react';

export const GridIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='12'
    height='12'
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M1.875 3C1.875 2.37868 2.37868 1.875 3 1.875H4.125C4.74632 1.875 5.25 2.37868 5.25 3V4.125C5.25 4.74632 4.74632 5.25 4.125 5.25H3C2.37868 5.25 1.875 4.74632 1.875 4.125V3Z'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M1.875 7.875C1.875 7.25368 2.37868 6.75 3 6.75H4.125C4.74632 6.75 5.25 7.25368 5.25 7.875V9C5.25 9.62132 4.74632 10.125 4.125 10.125H3C2.37868 10.125 1.875 9.62132 1.875 9V7.875Z'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M6.75 3C6.75 2.37868 7.25368 1.875 7.875 1.875H9C9.62132 1.875 10.125 2.37868 10.125 3V4.125C10.125 4.74632 9.62132 5.25 9 5.25H7.875C7.25368 5.25 6.75 4.74632 6.75 4.125V3Z'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M6.75 7.875C6.75 7.25368 7.25368 6.75 7.875 6.75H9C9.62132 6.75 10.125 7.25368 10.125 7.875V9C10.125 9.62132 9.62132 10.125 9 10.125H7.875C7.25368 10.125 6.75 9.62132 6.75 9V7.875Z'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
